//@ts-nocheck
import { getConfig } from ".././config/config";
import loggly_util from "../loggly-util";
const { APP_BASE_CHARTSTT_API_URL } = getConfig();
let scripInfo_cache_value = {};
export const getScripInfoData = async (requrl) => {
    var _a, _b;
    if (scripInfo_cache_value[(requrl === null || requrl === void 0 ? void 0 : requrl.Exch) + (requrl === null || requrl === void 0 ? void 0 : requrl.ExchType) + (requrl === null || requrl === void 0 ? void 0 : requrl.ScripCode)]) {
        return scripInfo_cache_value[(requrl === null || requrl === void 0 ? void 0 : requrl.Exch) + (requrl === null || requrl === void 0 ? void 0 : requrl.ExchType) + (requrl === null || requrl === void 0 ? void 0 : requrl.ScripCode)];
    }
    try {
        const response = await fetch(`${APP_BASE_CHARTSTT_API_URL}chart/scripinfo/${requrl === null || requrl === void 0 ? void 0 : requrl.Exch}/${requrl === null || requrl === void 0 ? void 0 : requrl.ExchType}/${requrl === null || requrl === void 0 ? void 0 : requrl.ScripCode}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + JSON.parse(localStorage.TokenResponseTv).access_token,
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        scripInfo_cache_value[(requrl === null || requrl === void 0 ? void 0 : requrl.Exch) + (requrl === null || requrl === void 0 ? void 0 : requrl.ExchType) + (requrl === null || requrl === void 0 ? void 0 : requrl.ScripCode)] = data.Data;
        if (((_a = data.Data) === null || _a === void 0 ? void 0 : _a.IsIndice) === "Y") {
            sessionStorage.setItem("isIndice" + (requrl === null || requrl === void 0 ? void 0 : requrl.ScripCode), (_b = data.Data) === null || _b === void 0 ? void 0 : _b.IsIndice);
        }
        return data.Data;
    }
    catch (error) {
        loggly_util.logAdvancedMessage(error, {
            error: error,
            APIURL: `${APP_BASE_CHARTSTT_API_URL}chart/scripinfo/${requrl === null || requrl === void 0 ? void 0 : requrl.Exch}/${requrl === null || requrl === void 0 ? void 0 : requrl.ExchType}/${requrl === null || requrl === void 0 ? void 0 : requrl.ScripCode}`,
        });
        console.error("Error while fetching scripInfo Data:", error);
        return null;
    }
};
